



export function degrees_to_rad(degrees) {
    return (degrees * Math.PI) / 180;
}


export function rad_to_degrees(rad) {
    return (rad * 180) / Math.PI;
}




// Helper function to convert data URL to Blob
export function dataURLToFileImage(dataURL, filename, type_mime) {
    const parts = dataURL.split(";base64,");
    const contentType = parts[0].split(":")[1];
    const byteString = atob(parts[1]);

    if (!type_mime) type_mime = "image/jpeg";

    let arrayBuffer = new ArrayBuffer(byteString.length);
    let uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
    }

    var blob = new Blob([uint8Array], { type: contentType });
    //const file = new File([blob], 'canvas_image.png', { type: 'image/png' }); // Specify the file name and type
    const file = new File([blob], filename, { type: "type_mime" }); // Specify the file name and type
    return file;
}



export function calculate_zoom_after_rotation(
    angulo_rotacion,
    displayWidth,
    displayHeight,
    fill_borders
) {
    //  console.group();
    //  console.log("angulo_rotacion = ", rad_to_degrees(angulo_rotacion));
    var hipotenusa_image = Math.sqrt(
        displayWidth ** 2 + displayHeight ** 2
    );

    var correction_rad = angulo_rotacion;

    var triangulo_izquierda_angulo_top = Math.asin(
        displayWidth / hipotenusa_image
    );
    var triangulo_izquierda_angulo_bottom = Math.asin(
        displayHeight / hipotenusa_image
    );

    var triangulo_derecha_angulo_top = Math.asin(
        displayWidth / hipotenusa_image
    );
    var triangulo_derecha_angulo_bottom = Math.asin(
        displayHeight / hipotenusa_image
    );

    /* 
                        console.log('triangulo_izquierda_angulo_top; ', rad_to_degrees(triangulo_izquierda_angulo_top));
                        console.log('triangulo_izquierda_angulo_bottom; ', rad_to_degrees(triangulo_izquierda_angulo_bottom));
                        console.log('triangulo_derecha_angulo_top; ', rad_to_degrees(triangulo_derecha_angulo_top));
                        console.log('triangulo_derecha_angulo_bottom; ', rad_to_degrees(triangulo_derecha_angulo_bottom));
         */

    var triangulo_izquierda_angulo_top_rotated =
        triangulo_izquierda_angulo_top - correction_rad;
    var triangulo_izquierda_angulo_bottom_rotated =
        triangulo_izquierda_angulo_bottom + correction_rad;

    var triangulo_derecha_angulo_top_rotated =
        triangulo_derecha_angulo_top + correction_rad;
    var triangulo_derecha_angulo_bottom_rotated =
        triangulo_derecha_angulo_bottom - correction_rad;

    /* 
        
                        console.log('triangulo_izquierda_angulo_top_rotated; ', rad_to_degrees(triangulo_izquierda_angulo_top_rotated));
                        console.log('triangulo_izquierda_angulo_bottom_rotated; ', rad_to_degrees(triangulo_izquierda_angulo_bottom_rotated));
                        console.log('triangulo_derecha_angulo_top_rotated; ', rad_to_degrees(triangulo_derecha_angulo_top_rotated));
                        console.log('triangulo_derecha_angulo_bottom_rotated; ', rad_to_degrees(triangulo_derecha_angulo_bottom_rotated));
        
         */

    var triangulo_izquierda_proyeccion_x =
        Math.sin(triangulo_izquierda_angulo_top_rotated) * hipotenusa_image;
    var triangulo_izquierda_proyeccion_y =
        Math.cos(triangulo_izquierda_angulo_top_rotated) * hipotenusa_image;

    var triangulo_derecha_proyeccion_x =
        Math.sin(triangulo_derecha_angulo_top_rotated) * hipotenusa_image;
    var triangulo_derecha_proyeccion_y =
        Math.cos(triangulo_derecha_angulo_top_rotated) * hipotenusa_image;

    /*         console.log('triangulo_izquierda_proyeccion_x: ', triangulo_izquierda_proyeccion_x);
                console.log('triangulo_izquierda_proyeccion_y: ', triangulo_izquierda_proyeccion_y);
                console.log('triangulo_derecha_proyeccion_x: ', triangulo_derecha_proyeccion_x);
                console.log('triangulo_derecha_proyeccion_y: ', triangulo_derecha_proyeccion_y);
        */

    triangulo_izquierda_proyeccion_x = Math.abs(
        triangulo_izquierda_proyeccion_x
    );
    triangulo_derecha_proyeccion_x = Math.abs(
        triangulo_derecha_proyeccion_x
    );
    triangulo_izquierda_proyeccion_y = Math.abs(
        triangulo_izquierda_proyeccion_y
    );
    triangulo_derecha_proyeccion_y = Math.abs(
        triangulo_derecha_proyeccion_y
    );

    var bounding_box_x = Math.max(
        triangulo_izquierda_proyeccion_x,
        triangulo_derecha_proyeccion_x
    );
    var bounding_box_y = Math.max(
        triangulo_izquierda_proyeccion_y,
        triangulo_derecha_proyeccion_y
    );
  
    bounding_box_y = Math.abs(bounding_box_y);
    bounding_box_x = Math.abs(bounding_box_x);

    var zoom_x = bounding_box_x / displayWidth;
    var zoom_y = bounding_box_y / displayHeight;

    // console.log("zoom_x: ", zoom_x);
    // console.log("zoom_y: ", zoom_y);

    // amplify or minify: CHECKBOX
    var zoom_para_no_margenes = Math.max(zoom_x, zoom_y);
    var zoom_para_que_entre_todo = Math.min(1 / zoom_x, 1 / zoom_y);

    /*
        if (document.getElementById('option_hide_white').checked) {
            zoom = zoom_para_no_margenes;
        } else {
            zoom = zoom_para_que_entre_todo;
        }
        */
    var zoom = 1;
    if (fill_borders) {
        zoom = zoom_para_no_margenes;
    } else {
        zoom = zoom_para_que_entre_todo;
    }

    /* 
                        console.log('zoom_x: ', zoom_x);
                        console.log('zoom_y: ', zoom_y);
                        console.log('zoom: ', zoom);
        
        
        
                        console.log('------------------------')
                        console.log('------------------------')
                        console.log('------------------------')
                        console.log('------------------------')
                        console.log('------------------------')
         */
    //  console.log("zOOM calculate_zoom_after_rotation() ", zoom);
    //  console.groupEnd();
    //  console.log("----------------------------");
    return zoom;
}